import React from 'react';
import { DialogTitle } from '@headlessui/react';
import { Control, Controller } from 'react-hook-form';
import { DatePicker } from '@/components/UI';

interface ModalHeaderProps {
  title?: string;
  control?: Control<any>;
  isPaidInitial?: boolean;
  isDisabled?: boolean;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({
  title,
  control,
  isPaidInitial,
  isDisabled
}) => {
  if (!title) return null;

  return (
    <DialogTitle
      as='h2'
      className='text-sm font-semibold text-gray-900 mb-3 flex items-center justify-between'
    >
      <span className='text-sm'>{title}</span>
      <div className='flex items-center gap-2'>
        <span className='text-xs font-medium text-slate-700'>Date:</span>
        <Controller
          name='date'
          control={control}
          render={({ field }) => (
            <DatePicker
              value={field.value}
              onChange={field.onChange}
              disabled={isPaidInitial || isDisabled}
              className={'!min-w-[150px] w-full'}
            />
          )}
        />
      </div>
    </DialogTitle>
  );
};

export default ModalHeader;
